import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dictionary, User } from '../../models/models';
import { DictionaryService } from '../../services/dictionary.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-search-user-component',
  templateUrl: './modal-search-user.component.html',
})
export class ModalSearchUserComponent implements OnInit {
  @Output() passEntry: EventEmitter<User[]> = new EventEmitter();
  @Input() title: string;
  @Input() multiple = false;
  organizations: Dictionary[];
  pageMode = 1;
  usersCount = 0;
  users: User[];
  lastName: string;
  firstName: string;
  middleName: string;
  organization: number;
  userId: number = null;
  currentUserId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private dictionaryService: DictionaryService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.dictionaryService.getOrganizations().subscribe((res) => {
      this.organizations = res;
    });
  }

  search() {
    this.userService
      .search(this.lastName, this.firstName, this.middleName, this.organization, this.currentUserId)
      .subscribe((res) => {
        this.users = res.data;
        this.usersCount = this.users.length;
        this.pageMode = 2;
      });
  }

  back() {
    this.pageMode = 1;
  }

  choose() {
    let usersSelected: User[] = [];
    if (this.multiple) {
      usersSelected = this.users.filter((item) => item.checked);
    } else {
      let user = {} as User;
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id == this.userId) {
          user = this.users[i];
        }
      }
      usersSelected.push(user);
    }

    this.passEntry.emit(usersSelected);
    this.activeModal.close();
  }
}
